export const LOCAL_STORAGE_TOKEN = "starflix-user-token"